import { render, staticRenderFns } from "./ArrowGray.vue?vue&type=template&id=fb2bb2d0&scoped=true&lang=pug"
import script from "./ArrowGray.vue?vue&type=script&lang=js"
export * from "./ArrowGray.vue?vue&type=script&lang=js"
import style0 from "./ArrowGray.vue?vue&type=style&index=0&id=fb2bb2d0&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2bb2d0",
  null
  
)

export default component.exports